import { StrictMode } from "react"

import { createRoot } from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
import angular from "angular"

import { queryClient } from "@/query/queryClient"

import { ChatSystemMessage, SystemMessage } from "./ChatSystemMessage"

interface ChatSystemMessageScope extends angular.IScope {
  systemMessage: SystemMessage | null
  isDisabled?: boolean
}

export function ChatSystemMessageDirective(): angular.IDirective {
  return {
    restrict: "E",
    scope: {
      systemMessage: "<",
      isDisabled: "<",
    },
    link: function (
      scope: ChatSystemMessageScope,
      element: angular.IAugmentedJQuery,
    ) {
      const root = createRoot(element[0])

      const render = () => {
        if (!scope.systemMessage) {
          return
        }

        // Wrap handleAction to ensure Angular digest cycle runs
        const wrappedSystemMessage = { ...scope.systemMessage }
        if (wrappedSystemMessage.handleAction) {
          const originalHandleAction = wrappedSystemMessage.handleAction
          wrappedSystemMessage.handleAction = () => {
            scope.$apply(() => {
              originalHandleAction()
            })
          }
        }

        root.render(
          <StrictMode>
            <QueryClientProvider client={queryClient}>
              <ChatSystemMessage
                systemMessage={wrappedSystemMessage}
                isDisabled={scope.isDisabled}
              />
            </QueryClientProvider>
          </StrictMode>,
        )
      }

      render()

      scope.$watch(
        "systemMessage",
        () => {
          render()
        },
        true,
      )

      scope.$on("$destroy", () => {
        root.unmount()
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any as angular.IDirective
}
